import type { KnowMore } from "@/Models/MNowMore/knowMore";
import type React from "react";

interface InfoImageProps {
  knowMore: KnowMore[];
  currentSlide: number;
}

export const DetailImageKnowMore: React.FC<InfoImageProps> = ({
  knowMore,
  currentSlide,
}) => {
  // buscar el item correspondiente al slide actual.
  const currentItem = knowMore[currentSlide];

  if (!currentItem) return null;

  //Guardamos los datos de cada detalle en un arreglo.
  const details = [
    currentItem.DetalleAImagen,
    currentItem.DetalleBImagen,
    currentItem.DetalleCImagen,
    currentItem.DetalleDImagen,
    currentItem.DetalleEImagen,
    currentItem.DetalleFImagen,
  ];

  //recorremos de uno en uno y mostramos por pantalla
  return (
    <div className={"p-2 mt-2 d-flex flex-column classInfo__developMX"}>
      {details.map((detalle, index) => (
        <div className={detalle.length > 0 ? "p-1" : "p-2"} key={index}>
          <span className="develop___ColorText develop__fontFamilys__titles develop__text__info">
            {detalle.length > 0 ? detalle : <br />}
          </span>
        </div>
      ))}
    </div>
  );
};
